/**
 * Деньги в кабинете.
 *
 * ТРИ ПРАВИЛА, КОТОРЫЕ НАРУШАЮТСЯ ЧАЩЕ ВСЕГО (01-основа.md §5.2).
 *
 * 1. Копейки показываются ВСЕГДА, даже нулевые: «1 800,00 ₽», а не «1 800 ₽». Цена
 *    без копеек рядом с ценой с копейками читается как другая сумма, а в одном списке
 *    они соседствуют постоянно.
 * 2. null — это НЕ ноль. Пустая цена означает «этому человеку деньги не показываем»
 *    (право finance.view или настройка «деньги видны мастеру»), и печатать вместо неё
 *    «0,00 ₽» значит сообщить мастеру, что услуга бесплатная.
 * 3. Разряды разделяются НЕРАЗРЫВНЫМ пробелом: «1 800,00 ₽», разорванное переносом
 *    строки на «1» и «800,00 ₽», в таблице читается как две разные суммы.
 */

const FORMAT = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** Сумма в копейках → «1 800,00 ₽». null — деньги скрыты, и это отдельный ответ. */
export function formatMoney(minor: number | null): string | null {
  if (minor === null) return null
  // Intl в разных версиях ставит то обычный пробел, то узкий неразрывный. Приводим
  // к одному неразрывному: иначе ширина колонки скачет между браузерами.
  return `${FORMAT.format(minor / 100).replaceAll(/[\s  ]/g, " ")} ₽`
}

/** Длительность в минутах → «40 мин», «1 ч 30 мин». */
export function formatMinutes(minutes: number): string {
  if (minutes < 60) return `${minutes} мин`
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest === 0 ? `${hours} ч` : `${hours} ч ${rest} мин`
}
